/**
 * Holds the raw File objects backing in-flight uploads.
 *
 * They deliberately live outside Redux: the store runs with serializableCheck
 * enabled and a File is not serializable. The store keeps only the metadata
 * needed to render a row, keyed by the same upload id used here.
 */
const files = new Map<string, File>()

export const uploadFileRegistry = {
  set(id: string, file: File): void {
    files.set(id, file)
  },

  get(id: string): File | undefined {
    return files.get(id)
  },

  remove(id: string): void {
    files.delete(id)
  },

  clear(): void {
    files.clear()
  },
}
